import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "column no-wrap" }

import _ from 'lodash'

type Value = string | number | Record<PropertyKey, unknown> | null

interface IProps {
  label?: string
  description?: string
  labelClass?: string
  descriptionClass?: string
  clickable?: boolean
  val?: Value
  disable?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseToggleLine' },
  __name: 'BaseToggleLine',
  props: /*@__PURE__*/_mergeModels({
    label: { default: '' },
    description: { default: '' },
    labelClass: { default: 'fs-15px fw-500' },
    descriptionClass: { default: 'fs-13px' },
    clickable: { type: Boolean, default: true },
    val: { default: null },
    disable: { type: Boolean, default: false }
  }, {
    "modelValue": { type: [Boolean, Array], ...{ required: true } },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {


const props = __props
const model = _useModel<boolean | Value[]>(__props, "modelValue")

function handleToggle() {
  if (props.disable) return

  if (typeof model.value === 'boolean') {
    model.value = !model.value
    return
  }

  const exists = model.value.some((value) => _.isEqual(value, props.val))
  model.value = exists ? model.value.filter((value) => !_.isEqual(value, props.val)) : [...model.value, props.val]
}

return (_ctx: any,_cache: any) => {
  const _component_k_toggle = _resolveComponent("k-toggle")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["BaseToggleLine row no-wrap items-center justify-between", { 'cursor-pointer': __props.clickable && !__props.disable, 'cursor-not-allowed': __props.disable }]),
    onClick: handleToggle
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "label", {}, () => [
          _createElementVNode("span", {
            class: _normalizeClass(["transition", [__props.disable ? 'text-cool-gray-60' : model.value ? 'text-cool-gray-100' : 'text-cool-gray-70', __props.labelClass]])
          }, _toDisplayString(__props.label), 3 /* TEXT, CLASS */)
        ]),
        _renderSlot(_ctx.$slots, "description", {}, () => [
          (__props.description)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["transition", [model.value ? 'text-cool-gray-70' : 'text-cool-gray-60', __props.descriptionClass]])
              }, _toDisplayString(__props.description), 3 /* TEXT, CLASS */))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _createVNode(_component_k_toggle, {
      modelValue: model.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      val: __props.val,
      disable: __props.disable
    }, null, 8 /* PROPS */, ["modelValue", "val", "disable"])
  ], 2 /* CLASS */))
}
}

})